// Continuar viendo — guarda progreso de visualización por usuario

const KEY = (email) => `watch_history_${email}`;

export function saveProgress(email, item) {
  // item: { id, type, title, thumbnail, progress (0-100), updatedAt }
  const history = getHistory(email);
  const idx = history.findIndex((h) => h.id === item.id && h.type === item.type);
  const entry = { ...item, updatedAt: new Date().toISOString() };
  if (idx >= 0) history[idx] = entry;
  else history.unshift(entry);
  // Keep only last 20
  localStorage.setItem(KEY(email), JSON.stringify(history.slice(0, 20)));
}

export function getHistory(email) {
  return JSON.parse(localStorage.getItem(KEY(email)) || "[]");
}

export function removeFromHistory(email, id, type) {
  const history = getHistory(email).filter((h) => !(h.id === id && h.type === type));
  localStorage.setItem(KEY(email), JSON.stringify(history));
}
